import React from "react";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import Switch from "components/common/Switch/Switch";
import { IPaiyaDetailsProps } from "./PaiyaDetails.interface";

const PaiyaDetails = (props: IPaiyaDetailsProps) => {
  const {
    citiesList,
    paiyaTypesList,
    handleSelectedCityChange,
    city,
    paiyaConfigCreation,
    handleSwitchChange,
  } = props;
  return (
    <FormSectionLayout subTitleText="Paiya details">
      <section className="form-group search-container">
        <SearchableSelect
          label="city"
          options={citiesList}
          id="city"
          onChange={handleSelectedCityChange}
          placeholder="Select city"
          selectedValue={city}
          isSearchable={false}
          isDisabled={false}
        />
        <SearchableSelect
          label="paiya type"
          options={paiyaTypesList}
          id="paiyaId"
          placeholder="DEFAULT"
          selectedValue="DEFAULT"
          isSearchable={false}
          // onChange={handleSelectedPaiyaChange}
          isDisabled={true}
        />
        <Switch
          id="status"
          label="DISPLAY ON APP"
          checked={paiyaConfigCreation.status}
          handleSwitch={handleSwitchChange}
        />
      </section>
    </FormSectionLayout>
  );
};

export default PaiyaDetails;
